/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Clones an object into a new instance
 * @param obj The object to be cloned
 * @returns A cloned version of the object
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function clone(obj: any): any {
  let clonedObj = null;

  if (obj != null) {
    const stringified = JSON.stringify(obj);
    clonedObj = JSON.parse(stringified);
  }

  return clonedObj;
}
